import React from "react";
import PolicyPage from "./PolicyPage";

const sections = [
  {
    title: "How a markdown is identified",
    paragraphs: ["A sale item shows a current selling price against a higher struck-through catalogue price. The lower figure used in the basket is the merchandise price for that order. A markdown does not, by itself, change the product description or condition promised on the item page."],
  },
  {
    title: "Stock and price changes",
    paragraphs: ["Marked-down stock remains subject to the availability displayed for its selected variant. Leaving an item in the basket does not lock its stock or price before order acceptance. A later price change is not applied retrospectively to an already accepted order."],
  },
  {
    title: "Condition disclosure",
    paragraphs: ["If a particular unit is reduced because of a known cosmetic or packaging condition, that condition must be disclosed before purchase to form part of the order. A general sale label does not disclose a defect and does not permit substitution with a damaged or materially different unit."],
  },
  {
    title: "Final-sale wording",
    paragraphs: ["A final-sale restriction affects a purchase only when it is displayed clearly for the item before Pay Now and is consistent with rights that cannot be excluded. A reduced price alone is not enough to create that restriction."],
  },
  {
    title: "Faults and safety",
    paragraphs: ["Where a reduced item is unsafe, faulty, incorrect or materially misdescribed, the customer can use the same evidence and remedy process as for a full-price item. A disclosed cosmetic characteristic is assessed against what the product page actually stated."],
  },
];

export default function SalePolicy() {
  return <PolicyPage title="Sale & Clearance Policy" intro="How displayed markdowns affect price, stock, condition and remedies." sections={sections} related={[["Discounts & Promotions", "/discounts-promotions"], ["Product Descriptions & Variation", "/product-information"]]} />;
}
